module.exports = __webpack_public_path__ + "static/media/hp_04.8c0bb712.jpg";